import {Component, Input} from '@angular/core';

@Component({
    selector: 'izivia-help-text',
    templateUrl: './iziviaHelpText.component.html',
    styleUrls: ['./iziviaHelpText.component.css'],
})
export class IziviaHelpTextComponent {
    @Input() text: string;
}
